import { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { getAuthorizationHeader } from 'redux/Api/employedsApi/employedsApi';
import styles from './Chat.module.scss';
import { Layout } from 'features/Layouts/Layouts';

interface ChatProps {
  version: 'customerCabinet' | 'orderChat';
  title: string;
}

export const Chat: React.FC<ChatProps> = ({ version, title }) => {
  const [token, setToken] = useState('');
  const chatDivRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/chat/get-access-token`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              Authorization: getAuthorizationHeader(),
            },
          },
        );
        const data = await res.json();
        setToken(data.token);
        localStorage.setItem('chatToken', data.token);

        if (chatDivRef.current) {
          chatDivRef.current.setAttribute('token', data.token);
          chatDivRef.current.setAttribute('version', version);
        }
      } catch (error) {
        console.log('Ошибка при получении токена:', error);
      }
    };

    fetchToken();
  }, [version]);

  useEffect(() => {
    if (token) {
      const link = document.createElement('link');
      link.href = process.env.REACT_APP_CHAT_CSS!;
      link.rel = 'stylesheet';
      link.type = 'text/css';
      document.head.appendChild(link);

      const script = document.createElement('script');
      script.src = process.env.REACT_APP_CHAT_SCRIPT!;
      script.async = true;

      document.body.appendChild(script);

      return () => {
        if (script.parentNode) {
          document.body.removeChild(script);
        }
        if (link.parentNode) {
          document.head.removeChild(link);
        }
      };
    }
  }, [token]);

  return (
    <Layout>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div
        id='root_chat'
        ref={chatDivRef}
        className={styles.chatRoot}
        data-cabinet-base={process.env.REACT_APP_BASE_URL || ''}
      />
    </Layout>
  );
};
